module.exports = __webpack_public_path__ + "media/images/svgs/sub_menu/referral_program-e86569b5de4f4d0690098074c4c024c8.svg";